
//import handleBarCompiler from '../../templates/lib/HandleBarCompiler'

import sdks from "../../braintree/config/sdks.json"


export const fetchContent =  (template, handleBarCompiler, context = {}) => {
    
    // await handleBarCompiler.registerPartials(template, namespace)
    return handleBarCompiler.compile(template, context)
}

const addListToElement = (element, list) => {
    const innerHTML = list.reduce((a, item) => a + item.outerHTML, '')
    element.innerHTML = innerHTML
}



export const initSearch =  () => {
    if(document.querySelector('#clientSDKFilter .search__filter')){
    const list = Array.from(document.querySelector('#clientSDKFilter .search__filter').children)
    const servers = Object.values(sdks.server).map(server => server.display)
    let firstIndex = -1, lastIndex = -1
    list.forEach((item, i) => {
        if(servers.includes(item.outerText)) {
            if(firstIndex === -1) firstIndex = i
            lastIndex = i
        }
    })
    const server = list.slice(firstIndex, lastIndex + 1)
    const client = list.slice(0, firstIndex)
    const content = list.slice(lastIndex + 1)

    const clientWrapper = document.querySelector('#clientSDKFilter .search__filter')
    const serverWrapper = document.querySelector('#serverSDKFilter .search__filter')
    const contentWrapper = document.querySelector('#contentFilter .search__filter')

    addListToElement(clientWrapper, client)
    addListToElement(serverWrapper, server)
    addListToElement(contentWrapper, content)
 }
}

export const initHeader = () => {
    const dropdownButton = document.querySelector('.header__dropdown .dropdown__title')
    dropdownButton.addEventListener('click', onDropdownTitleClick)
}

export const clearHeader = () => {
    const dropdownButton = document.querySelector('.header__dropdown .dropdown__title')
    dropdownButton.removeEventListener('click', onDropdownTitleClick)
    document.removeEventListener('click', onClickOutside)
}

function onDropdownTitleClick() {  
    const headerDropdown = document.querySelector('.header__dropdown')
    if(headerDropdown.classList.value.includes('header__dropdown--active')) {
        headerDropdown.classList.remove('header__dropdown--active')
    } else {
        headerDropdown.classList.add('header__dropdown--active')
        setTimeout(() => document.addEventListener('click', onClickOutside))
    }
}

function onClickOutside(event) {
    const dropdownSection = document.querySelector('.header__dropdown .dropdown__section')

    if(!dropdownSection.contains(event.target)) {
        const headerDropdown = document.querySelector('.header__dropdown')
        headerDropdown.classList.remove('header__dropdown--active')
        document.removeEventListener('click', onClickOutside)
    }
}